import { render } from "./ChangeStatusIcon.vue?vue&type=template&id=533390a8"
import script from "./ChangeStatusIcon.vue?vue&type=script&lang=js"
export * from "./ChangeStatusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__